import script from "./ProjectReportingThematic.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectReportingThematic.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectReportingThematic.vue?vue&type=style&index=0&id=aa442af6&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa442af6"]])

export default __exports__